import styled from 'styled-components';

export const Icon = styled.img`
 ${(p) => p.width && `
    width:${p.width};
 `};
 ${(p) =>p.height && `
    height:${p.height};
 `};
${(p) => p.top && `
   margin-top:${(p.theme.spacing[p.top])};
`};
${(p) => p.bottom && `
   margin-bottom:${(p.theme.spacing[p.bottom])};
`};
`;

export const Spacing = styled.div`
  ${(p) => p.top && `
      padding-top:${p.theme.spacing[p.top]};
  `};
  ${(p) => p.bottom && `
      padding-bottom:${p.theme.spacing[p.bottom]};
  `};
  ${(p) => p.left && `
     padding-left:${p.theme.spacing[p.left]};
  `};
  ${(p) => p.right && `
     padding-right:${p.theme.spacing[p.right]};
  `} ;
`;

export const Container = styled.div`
width:80%;
margin:0 auto;
@media(max-width:${(p) => p.theme.screen.lg}){
  width:90%;
}
@media(max-width:${(p) => p.theme.screen.md}){
  width:calc(100% - 40px);
}
`;

export const CardWrapper = styled.div`
display:grid;
width:100%;
grid-template-columns: 1fr 1fr 1fr 1fr;
grid-gap:${(p) => p.theme.spacing.md};
margin-top:${(p) => p.theme.spacing.sm};

@media(min-width:1600px){
  grid-gap:${(p) => p.theme.spacing.xl};
}
@media(max-width:${(p) => p.theme.screen.md}){
  grid-template-columns: 1fr 1fr 1fr;
}
@media(max-width:${(p) => p.theme.screen.sm}){
  grid-template-columns: 1fr 1fr;
}
@media(max-width:${(p) => p.theme.screen.xxs}){
  grid-template-columns: 1fr;
}
`;

export const Button = styled.button`
    background-color: #1b798d;
    border-radius: 30px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    padding: 15px 20px;
    border: 1px solid #1b798d;
    color: #ffffff;
    outline: none;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    display:flex;
    justify-content: center;
    cursor:pointer;
    width: 100%;
    margin-top:10px ;
    & :hover{
        background: #1c3741;
      color: #208da5;
      }
`;


export const Card = styled.div`
background-color:${(p) => p.theme.colors.cardBgColor};
padding:${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.md};
border-radius:${(p) => p.theme.radius.sm};
margin-bottom:${(p) => p.theme.spacing.sm};
@media(min-width:1600px){
  padding:${(p) => p.theme.spacing.md};
}
@media(max-width:${(p) => p.theme.screen.sm}){
  ${(p) => p.width && `
  min-width:${p.width};
  margin-bottom:${p.theme.spacing.none};
`};
}
`;

export const Heading = styled.div`
 font-size:${(p) => p.theme.font.size.lg};
 font-weight:${(p) => p.theme.font.weight.bolder};
 font-family:${(p) => p.theme.font.family.SweraDemo};
 ${(p) => p.top && `
   margin-top:${p.theme.spacing[p.top]};
 `};
 ${(p) => p.bottom && `
   margin-bottom:${p.theme.spacing[p.bottom]};
 `};
 ${(p) => p.left && `
   margin-left:${p.theme.spacing[p.left]};
 `};
 ${(p) => p.right && `
   margin-right:${p.theme.spacing[p.right]};
 `};

 @media(min-width:1600px){
  font-size:${(p) => p.theme.font.size.xl};
  margin:${(p) => p.theme.spacing.lg} ${(p) => p.theme.spacing.none};
 }
 @media(max-width:${(p) => p.theme.screen.xxs}){
   font-size:${(p)=> p.theme.font.size.md};
 }
`;

export const IconWrapper = styled.div`
/* background-color: #1c3741; */
background-color: #fff;
width:40px;
height: 40px;
min-width: 40px;
min-height: 40px;
display: flex;
align-items: center;
justify-content: center;
margin-right:${(p) =>p.theme.spacing.xs};
border-radius:50px;
-webkit-transform: perspective(1px) translateZ(0);
transform: perspective(1px) translateZ(0);
-webkit-transition-duration: 0.3s;
transition-duration: 0.3s;
-webkit-transition-property: transform;
transition-property: transform;
:hover, :focus, :active {
   -webkit-transform: scale(1.2);
   transform: scale(1.2);
}
`;